'use client';

import { Component, type ErrorInfo, type ReactNode } from 'react';

interface IProps {
    children: ReactNode;
    fallback: ReactNode;
    onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface IState {
    hasError: boolean;
}

/**
 *  React 尚无 Error Boundary hook，需用 class 实现；供函数组件包装复用
 *  todo 后续考虑使用 https://www.npmjs.com/package/react-error-boundary
 */
export default class ErrorBoundary extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): Partial<IState> {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.props.onError?.(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }

        return this.props.children;
    }
}
